export default {
  // Común
  common: {
    back: 'Volver',
    confirm: 'Confirmar',
    continue: 'Continuar',
    cancel: 'Cancelar',
    retry: 'Reintentar',
    total: 'Total',
    profile: 'Perfil',
    history: 'Historial',
    pleaseLogin: 'Inicia sesión primero',
    my: 'Mío',
    appName: 'Menú IA',
    loading: 'Cargando...',
    lang: 'Idioma',
    loadFailed: 'Error al cargar',
    operationFailed: 'Operación fallida',
    notSet: 'No establecido',
    country: 'País',
    all: 'Todo',
    searchPlaceholder: 'Buscar',
    noMore: 'No hay más'
  },

  // Inicio
  home: {
    allFoods: 'Toda la comida',
    headline: {
      sub: 'Descubre',
      main: 'Cocina de {country}'
    },
    articleTag: 'Guía',
    localGuideTitle: 'Guía local',
    recommendedArticlesAll: 'Todo',
    hotTopics: 'Temas populares',
    orderCallout: '¡No más pedir con "this, this"!',
    mustEatBadge: 'Imprescindible',
    countrySelect: {
      eyebrow: 'Destino',
      title: 'Elige un país',
      subtitle: 'Te mostramos inspiración culinaria y guías a tu medida',
      footer: 'Puedes cambiarlo en cualquier momento arriba a la izquierda'
    },
    loadCountriesFailed: 'Error al cargar países'
  },

  // Favoritos
  favorites: {
    title: 'Favoritos',
    empty: 'Aún no hay favoritos',
    foods: 'Comida',
    articles: 'Guías'
  },

  articleList: {
    title: 'Guías de {country}',
    empty: 'Aún no hay guías recomendadas'
  },

  // Detalle del plato
  dishDetail: {
    quantity: 'Cantidad',
    introduction: 'Descripción',
    loadingIntroduction: 'Obteniendo descripción...',
    getIntroduction: 'Ver descripción',
    addToCart: 'Añadir ({count})',
    selectQuantity: 'Selecciona cantidad',
    addedToCart: '{count} añadidos al carrito',
    loadFailed: 'Error al obtener descripción',
    noImage: 'Sin imagen',
    imageSearchEmpty: 'No se encontró una imagen precisa del plato',
    imageSearchAction: 'Buscar imágenes',
    aiImageGenerating: 'IA generando imagen',
    generating: 'Generando'
  },

  // Barra de pestañas
  tabbar: {
    home: 'Inicio',
    cameraOrder: 'Escanear',
    favorites: 'Favoritos',
    profile: 'Mío',
    camera: 'Cámara',
    menu: 'Menú'
  },

  // Cámara
  camera: {
    translate: 'Traducir a',
    takeOrUpload: 'Tomar foto o subir',
    uploadHint: 'Soporta hasta 9 fotos',
    addMore: 'Añadir más',
    order: 'Empezar a pedir',
    selectLanguage: 'Idioma de traducción',
    singleMode: 'Modo simple',
    multiMode: 'Modo múltiple',
    history: 'Historial',
    takePhotoError: 'Error al tomar foto, reintenta',
    cameraUnsupported: 'Cámara no soportada',
    cameraPermissionDenied: 'Permiso de cámara denegado, actívalo en ajustes',
    capture: 'Seguir tomando',
    tapToCapture: 'Tocar para tomar',
    tapToStart: 'Tocar para empezar',
    readyToCapture: 'Fotografiar menú',
    uploading: 'Subiendo...',
    uploadFailed: 'Error de subida',
    pleaseCapture: 'Toma una foto primero',
    maxPhotosReached: 'Máximo 9 fotos',
    photosAdded: '{count} fotos añadidas',
    confirmUpload: 'Confirmar subida',
    uploadMessage: 'Se subirán {count} fotos para reconocimiento',
    startRecognition: 'Empezar reconocimiento',
    confirmRecognition: 'Confirmar',
    willRecognize: 'Se reconocerán {count} fotos de menú',
    continueShooting: 'Seguir tomando',
    prepareUpload: 'Preparando...',
    compressingImage: 'Comprimiendo imagen...',
    compressionFailed: 'Error de compresión',
    useOriginal: 'Usar original',
    takePhoto: 'Tomar foto',
    selectFromGallery: 'Galería',
    operationFailed: 'Operación fallida, reintenta',
    processingPhoto: 'Procesando foto...',
    leavingPageWarning: 'Procesando fotos, ¿seguro que quieres salir?',
    restoreInfoMissing: 'Información de {count} fotos detectada pero faltan datos, vuelve a tomar',
    addedAndSkipped: '{added} añadidas, {skipped} archivos no válidos omitidos',
    remainingQuotaNotice: 'Estimado usuario {phone}: Vigencia de la suscripción: {days}',
    guide: {
      step1: 'Tomar foto',
      step2: 'IA reconoce y traduce',
      step3: 'Generar menú'
    }
  },

  // Iniciar sesión
  login: {
    title: 'Iniciar sesión',
    phone: 'Móvil',
    code: 'Código',
    phoneNumber: 'Número de móvil',
    verifyCode: 'Código de verificación',
    sendCode: 'Enviar código',
    resend: 'Reenviar',
    login: 'Entrar',
    loggingIn: 'Entrando...',
    success: 'Éxito',
    failed: 'Error de inicio de sesión, reintenta',
    loginSuccess: 'Inicio de sesión exitoso',
    loginFailed: 'Error al iniciar sesión',
    phonePlaceholder: 'Ingresa tu móvil',
    codePlaceholder: 'Ingresa el código',
    phoneRequired: 'Móvil requerido',
    codeRequired: 'Código requerido',
    phoneInvalid: 'Formato de móvil inválido',
    codeInvalid: 'Código debe ser 4-6 dígitos',
    phoneError: 'Formato de móvil incorrecto',
    codeError: 'Formato de código incorrecto',
    codeSent: 'Código enviado',
    resendCode: 'Reenviar',
    countdown: 'Reintentar en {count}s',
    retryAfter: 'Reintentar en {seconds}s',
    tooFrequent: 'Demasiado frecuente, espera un momento',
    dailyLimit: 'Límite diario alcanzado',
    sendFailed: 'Envío fallido, reintenta',
    agreeTips: 'Al iniciar sesión aceptas los términos y política de privacidad'
  },

  // Menú
  menu: {
    title: 'Menú',
    cartTitle: 'Carrito',
    checkout: 'Pedir',
    totalItems: 'Total {count} ítems',
    clearCart: 'Vaciar',
    emptyCart: 'Carrito vacío',
    aiRecommend: 'Recomendación IA',
    addToCart: 'Añadir',
    viewDetail: 'Detalles',
    price: 'Precio',
    quantity: 'Cantidad',
    currentMenu: 'Menú actual',
    clearCartConfirm: '¿Vaciar carrito?',
    noMenuData: 'Escanea el menú primero',
    confirmButton: 'Sí',
    cancelButton: 'No',
    hint: 'Aviso',
    noMenuItemsFound: 'No se encontraron ítems'
  },

  // Recomendación IA
  ai: {
    recommendedSets: 'Sets recomendados',
    dishCount: 'platos',
    selectSetHint: 'Elige un set recomendado',
    noSelectedDishes: 'Elige platos primero',
    setPrefix: 'Set',
    others: 'Otros',
    diningOptions: 'Preferencias',
    numberOfPeople: 'Personas',
    dietaryPreferences: 'Dieta',
    budgetRange: 'Presupuesto',
    getRecommendation: 'IA, ayúdame a pedir',
    noSpicy: 'Sin picante',
    vegetarian: 'Vegetariano',
    seafood: 'Mariscos',
    meat: 'Carne',
    loading: 'Generando recomendaciones...',
    recommendationTitle: 'IA te recomienda',
    tastePreference: 'Gusto',
    budgetPerPerson: 'Presupuesto por persona',
    allergyWarning: 'Alergias',
    sweet: 'Dulce',
    sour: 'Ácido',
    spicy: 'Picante',
    bitter: 'Amargo',
    umami: 'Umami',
    light: 'Ligero',
    heavy: 'Fuerte',
    dairy: 'Lácteos',
    eggs: 'Huevos',
    fish: 'Pescado',
    shellfish: 'Crustáceos',
    treeNuts: 'Frutos secos',
    peanuts: 'Cacahuetes',
    wheat: 'Trigo',
    soy: 'Soja',
    selectOptions: 'Elige tus preferencias',
    peopleCountError: 'Al menos 1 persona',
    budgetRangeError: 'El presupuesto debe ser positivo',
    budgetMaxMinError: 'El máximo debe ser mayor o igual al mínimo',
    submitFailed: 'Error al enviar, reintenta',
    minBudget: 'Mín',
    maxBudget: 'Máx',
    to: 'a',
    yuan: '¥',
    recommendProgress: 'Progreso IA',
    analyzing: 'Analizando menú...',
    generating: 'Generando propuesta...',
    recommendReason: 'Por qué recomendamos',
    menuCombination: 'Combinación',
    dietaryNotes: 'Notas dietéticas',
    servingSize: 'Porciones sugeridas',
    viewDetail: 'Detalles',
    goToCheckout: 'Pedir',
    dish: 'porción',
    menuOption: 'Set',
    recommendedDishes: 'Platos recomendados',
    categoryDishes: 'Categorías',
    order: 'Pedir',
    orderConversation: 'Diálogo de pedido'
  },

  // Subida
  upload: {
    title: 'Reconociendo',
    uploading: 'Subiendo...',
    recognizing: 'Reconociendo menú...',
    translating: 'Traduciendo...',
    generating: 'Generando resultados...',
    complete: 'Completado',
    failed: 'Falló',
    progress: 'Progreso',
    detailsTitle: 'Detalles',
    retake: 'Volver a tomar',
    retryUpload: 'Reintentar subida',
    buyBenefits: 'Mejorar beneficios',
    uploadingNow: 'Subiendo',
    aiRecognizingImages: 'IA reconociendo imágenes',
    aiTranslatingMenu: 'IA traduciendo menú',
    dynamicCompression: 'Compresión dinámica',
    ocrEngineIntegration: 'Motor OCR integrándose',
    agentEngineBoot: 'Motor agente iniciando',
    llmContextParsing: 'Análisis de contexto LLM',
    ragTargetLanguage: 'RAG emparejando idioma',
    cuisineRegionMapping: 'Mapeo cocina-región',
    enhancedTranslation: 'Traducción mejorada',
    dishMetadataClassification: 'Clasificación metadatos',
    semanticUiConstruction: 'Construcción UI semántica',
    confirmCancelTitle: 'Confirmar cancelación',
    confirmCancelMessage: '¿Cancelar reconocimiento?',
    preparingCount: 'Preparando {count} fotos...',
    startUploadCount: 'Subiendo {count} fotos',
    processingComplete: 'Proceso completado',
    navigatingSoon: 'Redirigiendo...',
    processingCompleteAndNavigate: 'Listo, redirigiendo',
    createBackgroundTask: 'Creando tarea en segundo plano...',
    noPhotoFound: 'No se encontraron fotos',
    pleaseRetake: 'Vuelve a tomar fotos',
    dataParseFailed: 'Error al analizar datos',
    photoDataParseFailed: 'Error datos de foto',
    photoDataFormatError: 'Formato de foto erróneo, vuelve a tomar',
    uploadFailedShort: 'Subida fallida',
    failedShort: 'Falló',
    errorTryAgain: 'Error, reintenta',
    menuNotFound: 'Menú no reconocido, vuelve a tomar',
    otherLlmErr: 'Error traducción menú',
    finalizing: 'Finalizando traducción',
    almostDone: 'Casi listo, espera'
  },

  // Error
  error: {
    network: 'Error de red, revisa tu conexión',
    server: 'Error de servidor, reintenta más tarde',
    timeout: 'Tiempo de espera agotado, reintenta',
    unknown: 'Error desconocido',
    auth: 'Autenticación fallida, inicia sesión de nuevo',
    selectImage: 'Selecciona una imagen',
    imageTooLarge: 'Imagen excede 20MB',
    processPhotoFailed: 'Error al procesar foto, reintenta',
    processFileFailed: 'Error al procesar archivo',
    pageStateError: 'Estado de página anormal, vuelve a tomar',
    processingPhotos: 'Procesando fotos, espera...',
    livePhotoNotSupported: 'Elige foto normal, Live Photo no soportada',
    microphonePermissionDenied: 'Permiso de micrófono denegado',
    microphoneNotFound: 'Micrófono no encontrado',
    microphoneInUse: 'Micrófono en uso',
    microphoneConfigNotSupported: 'Configuración de micrófono no soportada',
    recordingNotSupported: 'Grabación no soportada',
    recordingError: 'Error al grabar',
    forbidden: 'Sin permiso',
    notFound: 'Recurso no encontrado',
    requestFailed: 'Solicitud fallida',
    configError: 'Error de configuración'
  },

  // Conversación de pedido
  orderConversation: {
    title: 'Diálogo de pedido',
    menu_order: 'Pedir',
    quantity: 'Cantidad',
    translatedText: 'Traducción',
    orderText: 'Texto pedido',
    userSpeak: 'Mantén para hablar',
    waiterSpeak: 'Mantén para hablar',
    customerSpeak: 'Mantén para hablar',
    waiterSpec: 'Camarero',
    customerSpec: 'Cliente',
    dish_detail: 'Detalles',
    recording: 'Grabando...',
    common_confirm: 'Confirmar',
    customerRecording: 'Cliente hablando...',
    recognizing: 'Reconociendo...',
    translating: 'Traduciendo...',
    recordingFailed: 'Grabación fallida, revisa permisos',
    recognitionFailed: 'Reconocimiento de voz fallido',
    translationFailed: 'Traducción fallida',
    recognitionResult: 'Resultado',
    blankAudio: 'Audio demasiado corto',
    noDishes: 'No hay platos seleccionados',
    assistantIntro: 'Hola, soy el asistente de pedidos. El cliente quiere pedir lo siguiente. Toca para escuchar o mantén presionado el botón inferior para hablar y yo traduciré.'
  },

  // Perfil
  profile: {
    title: 'Mío',
    memberCard: {
      title: 'Beneficios',
      dynamicTitle: 'Eres usuario {status}<br />y disfrutas de:',
      feature1: ' Reconocimiento preciso',
      feature2: ' Traducción 20+ idiomas',
      feature3: ' Recomendación IA',
      feature4: ' Info cocina global',
      feature5: ' Traducción voz continua',
      featureUsageTemplate: '{feature} ({count})',
      unlock: 'Desbloquear',
      unlockBenefits: 'Mejorar beneficios'
    },
    menu: {
      privacy: 'Privacidad',
      terms: 'Términos',
      feedback: 'Feedback',
      serviceStatus: 'Estado servicio',
      about: 'Acerca de'
    },
    redeem: {
      button: 'Canjear',
      title: 'Canjear beneficio',
      description: 'Ingresa código para activar beneficios.',
      placeholder: 'Ingresa código',
      helper: 'Letras A-Z y números 0-9. Se ignoran espacios y no distingue mayúsculas.',
      submit: 'Canjear',
      cancel: 'Cancelar',
      success: 'Canje exitoso, beneficios actualizados',
      validation: {
        empty: 'Ingresa el código',
        length: 'Código debe tener 12 caracteres con letras y números',
        format: 'Formato incorrecto',
        checksum: 'Validación fallida, verifica'
      }
    },
    register: 'Eliminar cuenta',
    registerHint: 'Función en desarrollo',
    logout: 'Cerrar sesión',
    logoutConfirm: {
      title: 'Cerrar sesión',
      message: '¿Seguro que quieres salir?'
    },
    logoutSuccess: 'Sesión cerrada'
  },

  subscription: {
    subtitle: 'AI MENU PASS',
    title: 'Desbloquea beneficios IA',
    columns: {
      feature: 'Comparar'
    },
    plans: {
      freeUser: 'Usuario gratuito',
      trial: 'Prueba gratuita',
      trialTag: 'Tiempo limitado',
      oneDay: 'Plan 1 día',
      twoDay: 'Plan 2 días',
      threeDay: 'Plan 3 días',
      fiveDay: 'Plan 5 días'
    },
    actions: {
      tryNow: 'Probar',
      purchase: 'Comprar',
      continueTrial: 'Seguir probando',
      trialUnavailable: 'Prueba agotada',
      renew: 'Renovar',
      subscribed: 'Suscrito'
    },
    features: {
      validity: 'Validez restante',
      price: 'Precio',
      usageCount: 'Usos',
      aiTranslate: 'Traducción IA',
      aiTextDetail: 'Detalle texto',
      aiRecommend: 'Recomendación IA',
      aiOrder: 'Asistente pedido',
      aiVoice: 'Traducción voz'
    },
    values: {
      days: '{count} días',
      lifetime: 'De por vida',
      free: '0',
      price: '{amount} ¥',
      times: '{count} veces',
      notAvailable: '-',
      comingSoon: '- (Pronto)'
    },
    remarkTitle: 'Notas',
    remarksText:
      '1. Países soportados: Asia (Japón, Corea, Tailandia, Vietnam, Singapur, Malasia, Indonesia, EAU, Turquía); Europa (RU, Francia, Alemania, Austria, Suiza, Italia, Irlanda, España, Portugal, Rusia, Chequia, Hungría, Croacia, Países Bajos, Rumanía, Suecia); Norteamérica (EE.UU., Canadá, México); Sudamérica (Brasil, Argentina, Chile, Uruguay, Paraguay, Colombia, Venezuela, Panamá, Perú, Ecuador); Oceanía (Australia, NZ).' +
      '\nNota: Suiza soporta alemán, francés, italiano; Austria solo alemán; Sudamérica (salvo Brasil) soporta español.' +
      '\n2. La interpretación final de reglas y contenido pertenece a la empresa, conforme a la ley.',
    toast: {
      trialRedirect: 'Redirigiendo a activación de prueba',
      purchaseRedirect: 'Redirigiendo a compra',
      contactAdmin: 'Contacta admin para activar servicio',
      noQuota: 'Sin usos restantes. Compra en "Mío"',
      subscriptionExpired: 'Membresía expirada o agotada. Renueva en "Mío"',
      trialExhausted: 'Prueba agotada. Compra membresía en "Mío"',
      wechatRequired: 'Usa WeChat para pagar',
      paySuccess: 'Pago exitoso, beneficios actualizados',
      payCancelled: 'Pago cancelado',
      payFailed: 'Pago fallido, reintenta',
      payPending: 'El pago se está confirmando. Revisa el estado del pedido más tarde',
      productUnavailable: 'Producto no disponible, reintenta'
    },
    currentBenefits: 'Paquete actual',
    moreDetails: 'Detalles',
    remainingBenefits: 'Restante',
    totalBenefits: 'Total',
    expireTime: 'Vence',
    tabs: {
      compare: 'Comparar',
      detail: 'Detalles'
    },
    upgradeTitle: 'Mejorar paquete',
    trialNoteTitle: 'Nota prueba',
    trialNoteText: 'Los miembros de prueba pueden experimentar la traducción del menú y otras funciones. La prueba no afecta a los beneficios de suscripción.',
    statusDetail: {
      title: 'Detalles del plan',
      planName: 'Nombre del plan',
      startTime: 'Fecha de inicio',
      expireTime: 'Fecha de fin',
      totalCount: 'Total',
      status: 'Estado',
      statusMap: {
        pending: 'Pendiente',
        active: 'Activo',
        invalid: 'Inválido/Caducado'
      }
    },
    durations: {
      oneDay: '1 día',
      twoDay: '2 días',
      threeDay: '3 días',
      fiveDay: '5 días'
    },
    subscriptionSuffix: 'Suscripción',
    subscriptionName: 'Suscripción {duration}',
    fiveDayDesc: 'Validez de 5 días',
    validityOnly: 'Validez {duration}',
    validityAndUsage: 'Validez {duration}, incluye {usage} usos',
    usageCountSimple: 'Usos'
  }
}
